export function forEachBatch(items, batchSize, action) {
    for (var i = 0; i < items.length; i += batchSize) {
        var batch = [];
        var batchIndices = [];
        for (var j = 0; j < batchSize && i + j < items.length; ++j) {
            var currentIndex = i + j;
            batch.push(items[currentIndex]);
            batchIndices.push(currentIndex);
        }
        action(batch, batchIndices);
    }
}
//# sourceMappingURL=forEachBatch.js.map